const env = {
	REACT_APP_ENV: process.env.REACT_APP_ENV,
	REACT_APP_AUTH_API_URL: process.env.REACT_APP_AUTH_API_URL,
	REACT_APP_AUTH_APP_URL: process.env.REACT_APP_AUTH_APP_URL,
};

export default (key) => {
	if (key) return env[key] || null;
	return env.REACT_APP_ENV;
};
